import { ECircuitFilter, EPeriod, EPricePeriod, EVolumePeriod, } from "@domains/features/Markets/Equity/entities/iTopGainersLosers";
import { nifty50 } from "@domains/utils/indexData";
import { SET_PARAMS, } from "../../../interface/iDrivingMarketParams";
export const initCommonState = {
    index: nifty50.sym,
    exchange: nifty50.exc,
    limit: true,
    period: EPeriod.ONE_DAY,
};
export const initPriceState = {
    index: nifty50.sym,
    exchange: nifty50.exc,
    limit: true,
    period: EPricePeriod.THREE_DAY,
};
export const initVolumeState = {
    index: nifty50.sym,
    exchange: nifty50.exc,
    limit: true,
    period: EVolumePeriod.TODAY,
};
export const initPerformersState = {
    index: nifty50.sym,
    exchange: nifty50.exc,
    limit: true,
    period: EPeriod.ONE_WEEK,
};
export const initCircuitState = {
    index: nifty50.sym,
    exchange: nifty50.exc,
    limit: true,
    period: ECircuitFilter.NO_FILTER,
};
const drivingMarketParamsReducer = (state = initCommonState, action) => {
    switch (action.type) {
        case SET_PARAMS:
            return Object.assign(Object.assign({}, state), action.payload);
        default:
            return Object.assign({}, state);
    }
};
export default drivingMarketParamsReducer;
